import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import * as shape from 'd3-shape';

import { fuseAnimations } from '@fuse/animations';
import {DateMessageComponent} from 'app/main/pagina/tools/survey-status/survey-status.component';
import *  as $ from 'jquery';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';
import { CierreService } from 'app/main/wizard-cgo/services/cierre.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import Swal from 'sweetalert2';
import { DATOS_API } from 'app/auth/auth.datos';
import { zonasUTC } from 'app/main/pagina/zonasUtc';
const moment = require('moment');
const momentTz = require('moment-timezone');
//SERVICE
import { CloseService } from "../services/cierre.service";

import { AlertDialogComponent } from 'app/main/pagina/certificar/alertdialog/alertdialog.component';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_cierre } from 'app/idiomas/i18n/cierre/cierre.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {MatSnackBar} from '@angular/material/snack-bar';
interface adverModal {
  tipo: number;
  mensaje: string;
  diccionario: string;
  confirma: boolean;


};
@Component({
    selector     : 'cierre-dashboard',
    templateUrl  : './cierre.component.html',
    styleUrls    : ['./cierre.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class ProjectDashboardComponent implements OnInit
{
  rutaPagina: string;
 claveConteos:string;
    porcentaje: number;
    url: string;
    projects: any[];
    selectedProject: any;
    flagCierre: boolean = false;
    showButtonInstitute: boolean = true;
    dialogRef: any;
    fechaLanzamiento:any;
    // Datos certificar vigente
    productoMedir: backInter.prodGenerico;
    clavesConteos: backInter.getClaveConteos;
    //boolean paso completo
    pasoCompleto = false;

    widgets = {
        'tiempo'      : {
            'ranges'      : {
                'DT' : 'Today'
            },
            'currentRange': 'DT',
            'data'        : {
                'label': 'Dias restantes',
                'count': {
                    'DT' : 15
                },
                'extra': {
                    'label': 'Dias transcurridos',
                    'count': {
                        'DT' : 6
                    }
                }
            },
            'detail'      : '<h2>Más información</h2>Dia de lanzamiento de la encuesta:<br><b>01/09/2019</b><br><br>Día de cierre de la encuesta:<br><b>22/09/2019</b>'
        },
        'avance'      : {
            'ranges'      : {
                'DT' : 'Today'
            },
            'currentRange': 'DT',
            'data'        : {
                'label': 'Encuestas completas',
                'count': {
                    'DT' : '14%'
                },
                'extra': {
                    'label': 'Porcentaje restante',
                    'count': {
                        'DT' : '86%'
                    }
                }
            },
            'detail'      : '<h2>Más información</h2>Número de colaboradores encuestados: <b>343</b><br><br>Número de colaboradores con encuesta completa: <b>48</b><br><br>Número de colaboradores pendientes: <b>295</b>'
        }
    };

    dateNow = Date.now();
    diasRestantes:any;
    fechaCierre:any;

    constructor(
      public dialog: MatDialog,
      private cierreService: CierreService,
      private service : CloseService,
      private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      private translateSrv: TranslateService,
      private wizardService: WizardService,
      private _snackBar: MatSnackBar,
    ){
        lang_certificar.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });
        lang_cierre.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });

        setInterval(() => {
            this.dateNow = Date.now();
        }, 1000);

        // this.getStatusCierre();


        if(localStorage.getItem('instituto') == '1'){
          this.showButtonInstitute = false;
        }else{
          this.showButtonInstitute = true;
        }
        console.log("Si estas en cerrar medir");

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
     ngOnInit() {
       this.obtieneCertificarActual();

     }
     openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 2000,
      });
    }
     idMedirproducto:any;

     obtieneCertificarActual(){
       /// obtiene el producto certificar vigente
       this.cierreService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
         //console.log("Respuestas ");
         //console.log(data);
         this.idMedirproducto=data.productosMedir2[0].idProducto;
          this.getStatusCierre();
         let prodsMedir:backInter.prodGenerico[] = data.productosMedir2;
         var BreakException = {};
         try {
           //console.log("entro brothar");
             prodsMedir.forEach( (producto) => {
               //console.log("Productos");
               //console.log(producto);
               let fecha = producto.fechaProducto;
               let idProducto = producto.idProducto;
               this.idMedirproducto=producto.idProducto;
               if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
                 this.productoMedir = producto;
                 //this.getFechaLanzamiento();
                 throw BreakException;
               }
             });
         } catch (e) {
             if (e !== BreakException) throw e;
         };
         //obtiene el status del paso adicionales del certificar vigente
         this.cierreService.getStatusCierreMedir(this.productoMedir.idProducto).subscribe( (data: backInter.getStatusIndiv) => {
           if(data.estatus === 3)
             this.pasoCompleto = true;
         }, error  => {
            console.log("error de getStatusCierre");
            console.log(error);
          });

         this.getStatusModal();
        this.getClaveConteo();

         //obtiene las preguntas adicionales guardadas
       }, error  => {
         console.log("error al recuperar certificar vigente");
         console.log(error);
       });
     }

     getStatusModal(){
       let datos={
         productoId: this.productoMedir.idProducto,
         close: 1
       };
       console.log(datos);
       this.wizardService.getStatusModalMedir(datos).subscribe( (data: backInter.getStatusModal) => {
         if(data.estatus==1){
               this.modalInformativo('CIERRE');
         }
       });
     }

     updateStatusModal(){
       let datos={
         productoId: this.productoMedir.idProducto,
         close: 2
       };
       // console.log(datos);
       this.wizardService.updateStatusModalMedir(datos).subscribe( (data: any) => {
         // console.log(data);
       });
     }

     completarPaso(){
       if(this.pasoCompleto){
         this.aletaRestric('CIERRE.COMPLETADO',null,'warning');
        let textomessage = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.COMPLETADO';
        this.translateSrv.get(textomessage).subscribe((res: string) => { textomessage = res; });
        this._snackBar.open(textomessage, "Ok", {
          duration: 2000,
          horizontalPosition: "center",
          verticalPosition: "top",
          panelClass: ['background-red']
        });
       }
       else{
         if(this.flagCierre){
           this.aletaRestric('CIERRE.COMPLETAR',true);
         }
         else{
           this.aletaRestric('CIERRE.NADA',null,'warning');
         }
         //COLOCAR CONDICIONES Y VALIDACIONES PARA COMPLETAR EL PASO
       }

     }
     enviaOrdenWizard(){
       this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
     }

     aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

       let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
       let rspSi = 'MODALES.ACCIONES.aceptar';
       let rspNo = 'MODALES.ACCIONES.cancelar';
       this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
       this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
       this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

       if(confirmar){
         Swal.fire({
           title: texto,
           icon: 'warning',
           showCancelButton: true,
reverseButtons: true,


           confirmButtonText: rspSi,
           cancelButtonText: rspNo
         }).then((result) => {
           if (result.value) {
             this.cierreService.guardaStatusCierreMedir(this.productoMedir.idProducto).subscribe( (data: backInter.RespuestaGen) => {
               if(data.message == '217'){
                 this.aletaRestric('CIERRE.'+data.message,null,'success');
                 this.pasoCompleto = true;
                 this.enviaOrdenWizard();
               };
             });
           }
         });
       }
       else{
        let tipoMsg: any = tipo;
        if(tipoMsg=='success'){
         this.openSnackBar(texto,"OK");
        }else{
         Swal.fire({
           title: texto,
           icon: tipoMsg,
           confirmButtonText: rspSi,
           confirmButtonColor: '#e40601'
         });
        }
       }

     }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle the sidebar
     *
     * @param name
     */
    toggleSidebar(name): void
    {

    }

    private getStatusCierre(){
      var moment = require('moment');
      let data={
        productoId : localStorage.getItem('productoID')
      };
      console.log("Data estatus cierre");
      console.log(data);

        this.service.getAvanceEncuestaMedir(data)
          .subscribe(response => {
            console.log(response);
            console.log(response['fechaLanzamiento']);
            this.fechaLanzamiento=response['fechaLanzamiento'];

            if(response['message'] == 'Success'){
              this.fechaCierre=response['fechaCierre'];
              this.url = response['avance']['url'];
              this.porcentaje = +response['avance']['porcentaje'];
              if(response['completoMedir'] == '2'){
                this.flagCierre = true;
                this.url = response['avance']['url2'];
              }
            }
            let fechaActual= moment();
            let fechaCierre= moment(this.fechaCierre);
            if(fechaActual.isAfter(fechaCierre)){
              this.diasRestantes=0;
              console.log(this.diasRestantes);

             }else{
              this.diasRestantes=fechaCierre.diff(fechaActual,'days');
              console.log(this.diasRestantes);
            }


        }, error => {
          console.log("Estatus cierre encuesta");
          console.log(error);
        });
  }

  private cerrarEncuesta(){
      let data={
            productoId : this.productoMedir.idProducto
        };

        this.service.setCierreMedir(data)
          .subscribe(response => {


            if(response['message'] == '200'){
              console.log(response);
              this.getStatusCierre();
            }


        }, error => {
          //console.log(error);
        });
  }

  // showAlert(): void {
  //       this.dialogRef = this.dialog.open(AlertDialogComponent, {
  //         data: {'header': 'Info','message':'Do you want to continue with the survey close?','cancel':'No, cancel','accept':'Ok, continue'}
  //       });
  //
  //       this.dialogRef.afterClosed()
  //           .subscribe(result => {
  //           if(result == 'true'){
  //             this.cerrarEncuesta();
  //           }
  //         });
  //   }

  showAlert(){
    let texto = 'CIERRE.ALERT.MESSAGE';
    let rspSi = 'CIERRE.ALERT.BTN_CONFIRM';
    let rspNo = 'CIERRE.ALERT.BTN_CANCEL';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        this.cierreService.guardaStatusCierreMedir(this.productoMedir.idProducto).subscribe( (data: backInter.RespuestaGen) => {
          if(data.message == '217'){
            this.pasoCompleto = true;
            this.enviaOrdenWizard();
            this.cerrarEncuesta();
          };
        });
      }
    });
  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,

      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }

  generarClave(){
    let datos:any ={empresaId: localStorage.getItem('companyID'),productoId:localStorage.getItem('productoID'),claveProducto: 2};
    this.cierreService.saveConteosClaves(datos).subscribe( (data: backInter.getClaveConteos) => {
      this.claveConteos= data.clave._id;
      //console.log(this.claveConteos);
      //console.log(data);
    });
  }

  getClaveConteo(){
    let datos:any ={empresaId: localStorage.getItem('companyID'),productoId:localStorage.getItem('productoID')};
    console.log(datos);
    this.cierreService.getClaveConteos(datos).subscribe( (data: backInter.getClaveConteos) => {
      if (data.success==true) {
        this.claveConteos= data.clave._id;
        //console.log(data);
        //console.log(this.claveConteos);

      }else{
        console.log("no tiene clave de acceso");

      }
    });

  }

  copyMessage(val: string){
    let texto = 'CIERRE.CIERRE.COPYLINK';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    // let url = DATOS_API.url.split(":");
    // this.rutaPagina = url[1] + "/surveyadministrator/counting/" + val;
    this.rutaPagina = DATOS_API.urlConteos + val;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    // selBox.value=val;
    selBox.value=this.rutaPagina;
    //console.log(this.rutaPagina);
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.openSnackBar(texto,"OK");
    /*Swal.fire({
      icon: 'success',
      title: texto,

    });*/

  }
  auxCorreo_array:any;
  banderaArreglo=0;

  sendReminder(){
    //console.log("Fecha de lanzamiento");
    //console.log(this.fechaLanzamiento);
    let texto = 'CIERRE.ALERT_RE.MESSAGE';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    let rspSi = 'CIERRE.ALERT_RE.BTN_CONFIRM';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    let rspNo ='CIERRE.ALERT_RE.BTN_CANCEL';
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        if(this.fechaLanzamiento){
          var now = new Date();
          var date2 = new Date(now),
          mnth = ("0" + (date2.getMonth() + 1)).slice(-2),
            day = ("0" + date2.getDate()).slice(-2);
          var timestamp1 = new Date(this.fechaLanzamiento).getTime();
          var timestamp2 = new Date(date2).getTime();

          if(timestamp2>timestamp1){
            let datos:any ={productoId:this.idMedirproducto};
            this.cierreService. getRecordatorios_correoGenerico(datos).subscribe( (data: backInter.correosData) => {
              this.auxCorreo_array=data.recordatoriosManuales;
              if(this.auxCorreo_array.length == 0){
                this.cierreService.sendRecordatorioMedir(localStorage.getItem('productoID')).subscribe( (data: any) => {
                  let texto = 'CIERRE.LABEL5';
                  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                  this.openSnackBar(texto,"OK");
                   /* Swal.fire({
                      title: texto,
                      icon: "success",
                      confirmButtonColor: '#e40601'
                    });*/

                });
              }else{
                var pos= this.auxCorreo_array.length;
                var timestampRecordatorio1 = new Date(this.auxCorreo_array[pos-1].fechaRecordatorio).getTime();
                var timestampRecordatorio2 = new Date(date2).getTime();
                var tiempoRecordatorios = timestampRecordatorio2-timestampRecordatorio1;
                if(timestampRecordatorio1){
                    if(tiempoRecordatorios >= 86400000){
                      this.cierreService.sendRecordatorioMedirGenerico(localStorage.getItem('productoID')).subscribe( (data: any) => {
                      let texto = 'CIERRE.LABEL5';
                      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                      this.openSnackBar(texto,"OK");
                        /*Swal.fire({
                          title: texto,
                          icon: "success",
                          confirmButtonColor: '#e40601'
                        });*/
                      });

                    }else{
                      let texto = 'CIERRE.LABEL6';
                      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                      this.openSnackBar(texto,"OK");
                      /*Swal.fire({
                        title: texto,
                        icon: "error",
                        confirmButtonColor: '#e40601'
                      });*/

                    }
                }else{
                  this.cierreService.sendRecordatorioMedirGenerico(localStorage.getItem('productoID')).subscribe( (data: any) => {
                  let texto = 'CIERRE.LABEL5';
                  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                  this.openSnackBar(texto,"OK");
                    /*Swal.fire({
                      title: texto,
                      icon: "success",
                      confirmButtonColor: '#e40601'
                    });*/

                  });

                }

              }
            });

          }else{
            this.dialogDate_message(this.fechaLanzamiento);
            /*let texto = 'CIERRE.LABEL7';
             this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                Swal.fire({
                title: texto,
                icon: "error",
                confirmButtonColor: '#e40601'
             });*/

          }

        }
      }
    });

  }
  dialogDate_message(fecha){
    localStorage.setItem('fechamessage',''+fecha);
    localStorage.setItem('offsetPipe_message',''+this.offsetPipe);
    const dialogRef = this.dialog.open(DateMessageComponent, {
      width: '40%',
    });
  }
  zonasUTC = zonasUTC;
  indiceZona: number;
  diferenciaUtc: number;
  offsetPipe: string;
  calculoOffsetPipe(){
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
  }


  /*private getFechaLanzamiento(){

    let data={
      productoId : this.productoMedir.idMedir
      };
      this.cierreService.getFechaLanzamiento(data)
        .subscribe(response => {

          if(response['message'] == '200'){
            console.log("Respone medir");
            this.fechaLanzamiento = response['fechaLanzamiento'];
            console.log("Fecha message");
            console.log(data);
            console.log(this.fechaLanzamiento);
            let aux: string = '';
          }
      }, error => {
        //console.log(error);
      });
  }*/


}
